import React from 'react';
import { NumericFormat } from 'react-number-format';

interface PriceInputProps {
    value: string | number;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder: string;
    label: string;
    className?: string;
    disabled?: boolean;
    required?: boolean;
    ariaLabel?: string;
}

const PriceInput: React.FC<PriceInputProps> = ({
    value,
    onChange,
    placeholder,
    label,
    className,
    disabled,
    required,
    ariaLabel,
}) => {
    return (
        <label className="form-control">
            {!!label && (
                <div className="label">
                    <span className="label-text">{label}</span>
                </div>
            )}
            <NumericFormat
                value={value}
                onValueChange={(values, sourceInfo) => {
                    // Mudancas vindas do proprio valor (prop) nao sao digitacao: ignorar para nao marcar o preco como manual.
                    if (sourceInfo?.source === 'prop') return;
                    const { floatValue } = values;
                    onChange({
                        target: { value: floatValue !== undefined ? floatValue : '' },
                    } as React.ChangeEvent<HTMLInputElement>);
                }}
                thousandSeparator="."
                decimalSeparator=","
                prefix="R$ "
                className={`input input-bordered ${className ?? ''}`}
                placeholder={placeholder}
                decimalScale={2}
                fixedDecimalScale
                allowNegative={false}
                disabled={disabled}
                required={required}
                aria-label={ariaLabel}
            />
        </label>
    );
};

export default PriceInput;
